import React from "react";
import Top_bar from "../../Components/topBar/topBar";
import { Tab, Row, Col, ListGroup } from "react-bootstrap";
import AddWorkShift from "../Registration/WorkShift/addWorkShift";
import AltWorkShift from "../Registration/WorkShift/altWorkShift";
import DelWorkShift from "../Registration/WorkShift/delWorkShift";
import AltDays from "../Registration/WorkShift/altDays";
import "./prelude.css";
import BottomBar from "../../Components/bottomBar/bottomBar";
import TableList from "../../Components/tableList/TableList";
import Alert from "../../Components/alert/Alert";
import Api from "../../services/api";
import MessageTable from "../../Components/messageTable/MessageTable";
import ReportWorkShifts from "../Reports/reportWorkShifts";
import { handleColor } from "../../services/Functions";
class prelude_work_shift extends React.Component {
  render() {
    return (
      <>
        <header>
          <Top_bar />{" "}
        </header>
        <div className="prelude_container">
          <Sidebar></Sidebar>
        </div>
        <BottomBar></BottomBar>
      </>
    );
  }
}

class Sidebar extends React.Component {
  state = { data: [], keys: [], render: false, message: "", click: false };

  handleClick = () => {
    if (this.props.click === false) {
      this.setState({ click: true });
      return true;
    } else {
      this.setState({ click: false });
      return false;
    }
  };

  render() {
    const { show, message } = this.state;

    return (
      <Tab.Container defaultActiveKey="list">
        <Row style={{ width: "100%", height: "100%" }}>
          <div className="sidebar1">
            <div className="sidebar2">
              <Col className="sidebarColumn">
                <ListGroup>
                  <ListGroup.Item
                    mountOnEnter
                    unmountOnExit
                    id="lg1"
                    onClick={handleColor}
                    className="listGroup"
                    eventKey="list"
                  >
                    Turnos
                  </ListGroup.Item>
                  <ListGroup.Item
                    mountOnEnter
                    unmountOnExit
                    id="lg2"
                    onClick={handleColor}
                    className="listGroup"
                    action
                    eventKey="add"
                  >
                    Adicionar Turno
                  </ListGroup.Item>
                  <ListGroup.Item
                    mountOnEnter
                    unmountOnExit
                    id="lg3"
                    onClick={handleColor}
                    className="listGroup"
                    action
                    eventKey="alt"
                  >
                    Alterar Turno
                  </ListGroup.Item>
                  <ListGroup.Item
                    mountOnEnter
                    unmountOnExit
                    id="lg4"
                    onClick={handleColor}
                    className="listGroup"
                    action
                    eventKey="del"
                  >
                    Deletar Turno
                  </ListGroup.Item>
                  <ListGroup.Item
                    mountOnEnter
                    unmountOnExit
                    id="lg5"
                    onClick={handleColor}
                    className="listGroup"
                    action
                    eventKey="altDays"
                  >
                    Trocar dia
                  </ListGroup.Item>
                </ListGroup>
              </Col>
            </div>
            <Col
              className="col2"
              style={{ top: "5%", marginLeft: "1.5%", width: "100%" }}
            >
              {show ? (
                <Alert
                  show={show}
                  message={message}
                  parentCallback={this.callbackfunction}
                />
              ) : null}
              <Tab.Content>
                <Tab.Pane mountOnEnter unmountOnExit eventKey="list">
                  {this.handleClick ? <ReportWorkShifts /> : null}
                </Tab.Pane>
                <Tab.Pane mountOnEnter unmountOnExit eventKey="add">
                  {this.handleClick ? <AddWorkShift /> : null}
                </Tab.Pane>
                <Tab.Pane mountOnEnter unmountOnExit eventKey="alt">
                  {this.handleClick ? <AltWorkShift /> : null}
                </Tab.Pane>
                <Tab.Pane mountOnEnter unmountOnExit eventKey="del">
                  {this.handleClick ? <DelWorkShift /> : null}
                </Tab.Pane>
                <Tab.Pane mountOnEnter unmountOnExit eventKey="altDays">
                  {this.handleClick ? <AltDays /> : null}
                </Tab.Pane>
              </Tab.Content>
            </Col>
          </div>
        </Row>
      </Tab.Container>
    );
  }
}

export default prelude_work_shift;
